import {AppDispatch} from 'src/redux/store'
import {performAdminSessionExpiredLogout as performAdminSessionExpiredLogoutImpl} from 'src/utils/sessionExpiredLogout'

/** @deprecated Import from sessionExpiredLogout.ts */
export function performAdminSessionExpiredLogout(dispatch: AppDispatch): void {
  performAdminSessionExpiredLogoutImpl(dispatch)
}
